module.exports = __webpack_public_path__ + "static/media/Catherine Vinson Headshot.35fdf72f.jpeg";